export const filmSize = {
  width: 800,
  height: 540,
}
